import { getParent, types, flow } from 'mobx-state-tree';
import { Notification } from './Notification';
// import ENUMS from '../../constants/enums';

const URL = 'notification/v1';
// notification/getNotifications?AccountId=test1234axz

const NotificationsStore = types
  .model('NotificationsStore', {
    notifications: types.optional(types.array(Notification), []),
    total: 0,
    totalNotSeen: 0,
    page: 1,
    limit: 10,
  })
  .views(self => ({
    get accountCode() {
      return getParent(self).sessionStore.accountCode;
    },
    get start() {
      return (self.page - 1) * self.limit;
    },
    get isBetaUser() {
      return getParent(self).settingsStore.userProfile.isBetaUser;
    },
    get transport5007() {
      return getParent(self).transport5007;
    },
    get notificationsById() {
      return Object.fromEntries(self.notifications.map(notif => [notif.id, notif])) || {};
    },
  }))
  .actions(self => ({
    fetchNotifications: flow(function* fetchNotifications(addResults = false) {
      // if (process.env.REACT_APP_ENV === 'prod' && !self.isBetaUser) {
      //   return;
      // }
      try {
        const {
          data: { notifications },
        } = yield self.transport5007.fetch(
          `${URL}/notification/getNotifications?limit=${self.limit}&start=${self.start}`,
          {},
          {},
        );
        self.notifications = addResults
          ? [...self.notifications, ...notifications.notificationsDto]
          : notifications.notificationsDto;
        self.total = notifications.totalItems;
        self.totalNotSeen = notifications.totalNotSeen;
      } catch (err) {
        console.error(err);
      }
    }),
    markSeenNotification: flow(function* markSeenNotification(id) {
      try {
        yield self.transport5007.put(`${URL}/notification/markAsSeen`, { id });
      } catch (err) {
        console.error(err);
      }
    }),
    markSeenAllNotifications: flow(function* markSeenAllNotifications() {
      try {
        yield self.transport5007.put(`${URL}/notification/markAllAsSeen`);
        self.notifications.forEach(notif => notif.setSeen());
        self.totalNotSeen = 0;
      } catch (err) {
        console.error(err);
      }
    }),
    fetchFirstPage: flow(function* fetchFirstPage() {
      self.setPage(1);
      yield self.fetchNotifications();
    }),
    fetchNextPage: flow(function* fetchNextPage(addResults) {
      self.setPage(self.page + 1);
      yield self.fetchNotifications(addResults);
    }),
    setPage: page => {
      self.page = page;
    },
    setTotalNotSeen: ttl => {
      self.totalNotSeen = ttl;
    },
  }));

export default NotificationsStore;
